import { releaseName } from 'config/constants'
import { widget } from 'ui/widget/widget'

console.info('try on', releaseName)
widget.startup()
